import { useEffect } from 'react';

import { hasArrowKeyOwner } from '../utils/arrowKeyOwnership';

const ROW_HEIGHT = 68;

const useCalendarKeyboardScroll = ({ getScrollNode, isActive }) => {
  useEffect(() => {
    if (!isActive) return undefined;

    const handleKeyDown = (e) => {
      if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
      if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;

      const tag = e.target.tagName;
      if ((tag === 'INPUT' && e.target.type !== 'checkbox')
        || tag === 'TEXTAREA'
        || e.target.isContentEditable) {
        return;
      }

      /** An open popup owns the arrows while it navigates its own rows.
       * Scrolling under it dispatches calendarContainerScrollPosition, which
       * those popups treat as the coach scrolling and close on. Bail without
       * preventDefault so the popup's own handler still sees the key. */
      if (hasArrowKeyOwner()) return;

      const node = getScrollNode();
      if (!node) return;

      e.preventDefault();
      node.scrollBy({
        top: e.key === 'ArrowDown' ? ROW_HEIGHT : -ROW_HEIGHT,
        behavior: 'smooth',
      });
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [getScrollNode, isActive]);
};

export default useCalendarKeyboardScroll;
